<template>
  <div>
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid row">
      <div class="col-xl-12">
        <div class="row">
          <div class="col-xl-12 block br-t-l-0 mb-3">
            <head-menu :col="12" class="d-xl-flex" :headline="navbarTitel"></head-menu>
            <div class="row mt-2">
              <div class="ml-4 mr-2">
                <button
                  v-if="editable"
                  v-shortkey.once="['ctrl', 's']"
                  class="btn btn-success"
                  :disabled="!speichernMoeglich || loading"
                  @click="speichern"
                  @shortkey="speichern"
                >
                  {{ $t("global.save") }}
                </button>
              </div>
              <div class="mr-2">
                <button class="btn btn-primary" @click="zurListe">
                  <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />{{ $t("global.tolist") }}
                </button>
              </div>
              <div v-if="kontextRoute" class="mr-2">
                <router-link class="btn btn-primary" :to="kontextRoute">
                  <font-awesome-icon icon="fa-duotone fa-arrow-circle-right" class="mr-2" />{{ kontextBezeichnung }}
                </router-link>
              </div>
              <div class="ml-auto mr-3">
                <button v-if="editable && id" class="btn btn-danger" @click="oeffneLoeschenModal">
                  <font-awesome-icon icon="fa-duotone fa-trash" />
                  {{ $t("global.delete") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Stammdaten -->
      <div class="col-xl-12">
        <container-headline :headline="$t('global.masterdata')" :col="6"></container-headline>
        <div class="row mb-3">
          <div class="col-xl-12 block br-t-l-0">
            <div class="eingabe-panel-kopf p-3">
              <!-- Kontext nur bei neuen Kontingenten wählbar -->
              <div v-if="!id" class="row">
                <div class="col-xl-6">
                  <single-select-lehrgang
                    id="hotelkontingent-lehrgang"
                    :lehrgang="neuLehrgang"
                    :label="$t('global.educationcourse')"
                    :allowOpen="false"
                    :editable="editable && !neuKurzveranstaltung.id"
                    @confirmed="setLehrgang"
                  />
                </div>
                <div class="col-xl-6">
                  <single-select-veranstaltung
                    id="hotelkontingent-kurzveranstaltung"
                    :veranstaltung="neuKurzveranstaltung"
                    :typen="[$CONST('VERANSTALTUNGSTYPEN').SHORTEVENT]"
                    :label="$t('global.shortevent')"
                    :allowOpen="false"
                    :editable="editable && !neuLehrgang.id"
                    @confirmed="setKurzveranstaltung"
                  />
                </div>
              </div>
              <div v-else class="row">
                <div class="col-xl-6">
                  <div class="form-group">
                    <input :value="kontextBezeichnung" class="form-control" readonly placeholder=" " />
                    <label>{{ lehrgangId ? $t("global.educationcourse") : $t("global.shortevent") }}</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-6">
                  <div class="form-group">
                    <v-select
                      v-model="kontingent.gebaeude"
                      label="bezeichnung"
                      :options="gebaeude"
                      :reduce="(g) => g.id"
                      :disabled="!editable"
                      :placeholder="$t('global.hotel')"
                    >
                      <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                    </v-select>
                    <label :class="{ 'text-danger': !kontingent.gebaeude }">{{ $t("global.hotel") }}</label>
                  </div>
                </div>
                <div v-if="lehrgangId" class="col-xl-6">
                  <div class="form-group">
                    <v-select
                      v-model="kontingent.veranstaltung"
                      label="bezeichnung"
                      :options="module"
                      :reduce="(m) => m.id"
                      :disabled="!editable"
                      :placeholder="$t('global.allmodules')"
                    >
                      <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                    </v-select>
                    <label>{{ $t("global.module") }}</label>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <v-select
                      v-model="kontingent.verrechnungsposition"
                      :getOptionLabel="(p) => (p.artikel ? p.artikel.bezeichnung : p.id)"
                      :options="verrechnungspositionen"
                      :reduce="(p) => p.id"
                      :disabled="!editable || !kontextId"
                      :placeholder="$t('global.clearingitempernight')"
                    >
                      <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                    </v-select>
                    <label>{{ $t("global.clearingitempernight") }}</label>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="form-group">
                    <input
                      v-model.number="kontingent.kontingent"
                      class="form-control"
                      type="number"
                      min="0"
                      :readonly="!editable"
                      placeholder=" "
                    />
                    <label>{{ $t("global.quota") }}</label>
                  </div>
                </div>
                <div v-if="id" class="col-xl-3">
                  <div class="form-group">
                    <input :value="belegungText" class="form-control" readonly placeholder=" " />
                    <label>{{ $t("global.maxoccupancypernight") }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reiter -->
      <div v-if="id" class="col-xl-12">
        <div class="row">
          <div class="col-xl-12 p-0">
            <ul class="nav nav-tabs mt-3 fs-28">
              <li class="nav-item">
                <router-link
                  class="primary-headline-text nav-link"
                  :class="{ active: anzeige === 0 }"
                  :to="{ name: 'hotelkontingent', params: { id: id, anzeige: 0 } }"
                >
                  {{ $t("global.roomreservations") }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-xl-12 p-0">
            <div class="tab-container p-3">
              <div v-show="anzeige === 0">
                <div class="row mb-2">
                  <div class="ml-3">
                    <button v-if="editable" class="btn btn-success" @click="reservationOeffnen(null)">
                      <font-awesome-icon icon="fa-regular fa-plus" class="mr-2" />{{ $t("global.new") }}
                    </button>
                  </div>
                </div>
                <b-table
                  small
                  responsive
                  show-empty
                  sort-icon-left
                  tbody-tr-class="item"
                  :items="reservationen"
                  :fields="reservationFields"
                  :busy="loading"
                  @row-dblclicked="(item) => reservationOeffnen(item.id)"
                >
                  <template v-slot:cell(voranreise)="row">
                    <font-awesome-icon v-if="row.item.voranreise" icon="fa-solid fa-check" />
                  </template>
                  <template #cell(edit)="row">
                    <div role="button" @click="reservationOeffnen(row.item.id)">
                      <font-awesome-icon icon="fa-regular fa-pencil" size="sm" />
                    </div>
                  </template>
                  <template #empty>
                    <div class="text-center text-primary my-2">
                      <strong>{{ $t("global.nodataavailable") }}</strong>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <zimmerreservation-modal
      v-if="id"
      ref="zimmerreservationModal"
      id="hotelkontingent-zimmerreservation-modal"
      :veranstaltung="veranstaltungKontextId"
      :lehrgang="lehrgangId"
      :module="module"
      :hotelkontingente="hotelkontingente"
      :reservationstypen="reservationstypen"
      :vorgabeKontingent="geladenesKontingent"
      :editable="editable"
      @saved="laden"
    />

    <loeschen-modal id="hotelkontingent-loeschen-modal" @confirmed="loeschen" />
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import HeadMenu from "@/components/HeadMenu";
import ContainerHeadline from "@/components/ContainerHeadline";
import Navbar from "@/components/Navbar";
import LoadingOverlay from "@/components/global/LoadingOverlay";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import SingleSelectLehrgang from "@/components/global/SingleSelectLehrgang";
import SingleSelectVeranstaltung from "@/components/global/SingleSelectVeranstaltung";
import ZimmerreservationModal from "@/components/Zimmer/ZimmerreservationModal";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { LADE_AUSWAHLWERTE_RESSOURCEN } from "@/store/ressourcen/actions.type";

import store from "@/store";
import page from "@/mixins/Page";

/**
 * Maske Hotelkontingent (bxc_zimmer) inkl. Reiter mit den Reservationen dieses Kontingents.
 * Der Kontext (Lehrgang bzw. Kurzveranstaltung) wird über den Zimmer-Reiter-Endpunkt nachgeladen.
 */
export default {
  name: "Hotelkontingent",
  components: {
    HeadMenu,
    Navbar,
    ContainerHeadline,
    LoadingOverlay,
    LoeschenModal,
    SingleSelectLehrgang,
    SingleSelectVeranstaltung,
    ZimmerreservationModal,
  },
  metaInfo() {
    return {
      titleTemplate: () => this.navbarTitel,
    };
  },
  mixins: [page],
  store,
  props: {
    id: { type: String, default: null },
    anzeige: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      geladenesKontingent: null,
      kontingent: { gebaeude: null, veranstaltung: null, verrechnungsposition: null, kontingent: null },
      neuLehrgang: {},
      neuKurzveranstaltung: {},
      module: [],
      hotelkontingente: [],
      reservationstypen: [],
      reservationen: [],
      verrechnungspositionen: [],
    };
  },
  computed: {
    gebaeude() {
      return this.$store.state.ressourcen.gebaeude;
    },
    lehrgangId() {
      return this.geladenesKontingent?.lehrgang?.id || this.neuLehrgang?.id || null;
    },
    // Kurzveranstaltung als Kontext (beim Lehrgang ist veranstaltung das Modul)
    veranstaltungKontextId() {
      if (this.lehrgangId) return null;
      return this.geladenesKontingent?.veranstaltung?.id || this.neuKurzveranstaltung?.id || null;
    },
    kontextId() {
      return this.lehrgangId || this.veranstaltungKontextId;
    },
    kontextBezeichnung() {
      if (this.geladenesKontingent) {
        return this.lehrgangId
          ? this.geladenesKontingent.lehrgang.bezeichnung
          : this.geladenesKontingent.veranstaltung?.bezeichnung;
      }
      return this.neuLehrgang?.bezeichnung || this.neuKurzveranstaltung?.bezeichnung || "";
    },
    kontextRoute() {
      if (!this.id || !this.kontextId) return null;
      return this.lehrgangId
        ? { name: "bildungsgang", params: { lehrgangid: this.lehrgangId, anzeige: 6 } }
        : { name: "Kurzveranstaltung", params: { kurzveranstaltungid: this.veranstaltungKontextId, anzeige: 9 } };
    },
    navbarTitel() {
      const hotel = this.geladenesKontingent?.gebaeude?.bezeichnung;
      return hotel ? `${this.$t("global.hotelquota")}: ${hotel}` : this.$t("global.hotelquota");
    },
    belegungText() {
      if (!this.geladenesKontingent) return "";
      const k = this.geladenesKontingent;
      const max = k.kontingent != null ? `${k.maxBelegungProNacht} / ${k.kontingent}` : `${k.maxBelegungProNacht}`;
      return `${max} (${k.anzahlReservationen} ${this.$t("global.roomreservations")})`;
    },
    speichernMoeglich() {
      return !!(this.kontingent.gebaeude && this.kontextId);
    },
    reservationFields() {
      const fields = [
        { key: "person.bezeichnung", label: this.$t("global.person"), sortable: true },
        { key: "reservationstyp.bezeichnung", label: this.$t("global.reservationtype"), sortable: true },
      ];
      if (this.lehrgangId) fields.push({ key: "veranstaltung.bezeichnung", label: this.$t("global.module"), sortable: true });
      fields.push(
        { key: "anreise", label: this.$t("global.arrival") },
        { key: "abreise", label: this.$t("global.departure") },
        { key: "naechte", label: this.$t("global.nights") },
        { key: "voranreise", label: this.$t("global.arrivaltheeveningbefore") },
        { key: "edit", label: "" }
      );
      return fields;
    },
  },
  watch: {
    id() {
      this.laden();
    },
  },
  created() {
    // editable kommt als data aus dem Page-Mixin (Computed würde dort ignoriert)
    this.editable = this.zimmerRecht("update");
    if (this.gebaeude.length == 0) this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`);
    this.laden();
  },
  methods: {
    laden() {
      if (!this.id) return;
      this.loading = true;
      AppApi.get("zimmer/", { params: { id: this.id } })
        .then((response) => {
          const k = response.data;
          this.geladenesKontingent = k;
          this.kontingent = {
            gebaeude: k.gebaeude?.id || null,
            veranstaltung: k.lehrgang ? k.veranstaltung?.id || null : null,
            verrechnungsposition: k.verrechnungsposition?.id || null,
            kontingent: k.kontingent,
          };
          return this.ladeKontext();
        })
        .catch((e) => this.$notify(apiErrorToAlert(e)))
        .finally(() => {
          this.loading = false;
        });
    },
    ladeKontext() {
      if (!this.kontextId) return Promise.resolve();
      const params = this.lehrgangId ? { lehrgang: this.lehrgangId } : { veranstaltung: this.veranstaltungKontextId };
      this.ladeVerrechnungspositionen();
      return AppApi.get("zimmer-reiter/", { params }).then((response) => {
        this.module = response.data.module || [];
        this.hotelkontingente = response.data.hotelkontingente || [];
        this.reservationstypen = response.data.reservationstypen || [];
        this.reservationen = (response.data.reservationen || []).filter((r) => r.zimmer === this.id);
      });
    },
    ladeVerrechnungspositionen() {
      const params = this.lehrgangId ? { lehrgang: this.lehrgangId } : { veranstaltung: this.veranstaltungKontextId };
      Api.get("/rechnungslegung/verrechnungsposition/", { params }).then((response) => {
        this.verrechnungspositionen = response.data || [];
      });
    },
    setLehrgang(lehrgang) {
      this.neuLehrgang = lehrgang || {};
      this.kontingent.veranstaltung = null;
      this.kontingent.verrechnungsposition = null;
      this.ladeKontext();
    },
    setKurzveranstaltung(veranstaltung) {
      this.neuKurzveranstaltung = veranstaltung || {};
      this.kontingent.verrechnungsposition = null;
      this.ladeKontext();
    },
    speichern() {
      if (this.loading || !this.speichernMoeglich) return;
      this.loading = true;

      const json = {
        gebaeude: this.kontingent.gebaeude,
        lehrgang: this.lehrgangId,
        veranstaltung: this.lehrgangId ? this.kontingent.veranstaltung : this.veranstaltungKontextId,
        verrechnungsposition: this.kontingent.verrechnungsposition,
        kontingent: this.kontingent.kontingent === "" ? null : this.kontingent.kontingent,
      };

      const request = this.id
        ? AppApi.put("zimmer/", json, { params: { id: this.id } })
        : AppApi.post("zimmer/", json);

      request
        .then((response) => {
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.hotelquotasavedsuccessfully"),
          });
          if (!this.id) {
            this.$router.replace({ name: "hotelkontingent", params: { id: response.data.id, anzeige: 0 } });
          } else {
            this.laden();
          }
        })
        .catch((e) => this.$notify(apiErrorToAlert(e)))
        .finally(() => {
          this.loading = false;
        });
    },
    reservationOeffnen(reservationId) {
      this.$refs.zimmerreservationModal.oeffnen(reservationId);
    },
    zurListe() {
      this.$router.push({ name: "hotelkontingent-liste" });
    },
    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "hotelkontingent-loeschen-modal");
    },
    loeschen() {
      AppApi.delete("zimmer/", { params: { ids: this.id } })
        .then(() => this.zurListe())
        .catch((e) => this.$notify(apiErrorToAlert(e)));
    },
  },
};
</script>
